export enum OfficerAppointmentType {
  Director = 1,
  Secretary = 2,
  AlternativeDirector = 3,
  PublicOfficer = 10,
}
